import React from "react";
import {
  ShowController,
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceField,
} from "react-admin";
import { parse } from "query-string";
import CustomShowActions from "../../components/CustomShowActions.js";

const PanelEventShow = (props) => {
  const { organization_id } = parse(props.location.search);
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <Show
          {...props}
          actions={<CustomShowActions overrideOrgID={organization_id} />}
          title="Zone"
        >
          <SimpleShowLayout>
            <ReferenceField
              label="Organization"
              source="org_id"
              reference="organizations"
              link="show"
            >
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField
              label="Panel"
              source="panel_id"
              reference="panels"
              link="show"
            >
              <TextField source="uid" />
            </ReferenceField>
              <TextField source="createdAt" label="Created" />
              <TextField source="eventType" label="Event Type" />
              <TextField source="payload" label="Payload" />
          </SimpleShowLayout>
        </Show>
      )}
    </ShowController>
  );
};

export default PanelEventShow;
